import { useState } from 'react';
import { Outlet } from 'react-router-dom';
import Sidebar from './Sidebar';
import Topbar from './Topbar';
export default function Layout() {
  const [mobileNavOpen,setMobileNavOpen]=useState(false);
  return <div className="admin-shell"><Sidebar mobileOpen={mobileNavOpen} onClose={()=>setMobileNavOpen(false)}/><Topbar onMenu={()=>setMobileNavOpen(true)}/><main className="admin-main"><div className="admin-page"><Outlet/></div></main></div>;
}
